import styled from "@emotion/styled";
import { Variables } from "@repo/skapa";

export const ActionContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${Variables.space50};
  row-gap: ${Variables.space50};
  justify-content: flex-start;

  @media (max-width: 600px) {
    justify-content: left;
  }
`;
